'use strict'

import listings from './listings'
import listingsFilter from './listings.filter'

const self = {
  currentPage : 0,
  perPage : 10,
  loadMore : false,
  endOfResults : false,

  setNextPage : () => {
    self.disable()
    self.currentPage += 1
  },

  reset : () => {
    self.disable()
    self.currentPage = 0
    self.endOfResults = false
  },

  disable : () => self.loadMore = false,

  enable : () => self.loadMore = true,

  noMoreResults : () => {
    console.log( `No More Results` )
    self.endOfResults = true
  }

}

export default self
